const platformLanguage = {
    languageArray: ['en', 'de'],
};
export default platformLanguage;